/** (c) Kids-Smart.ru
 * Author: -AF-
 * Date: 15.06.2025
 */

(function() {
  const canDownloadPreview = (preview) => {
    return parseInt(preview.getAttribute('data-can-download')) === 1;
  };

  const isPremiumPreview = (preview) => {
    return parseInt(preview.getAttribute('data-is-premium')) === 1;
  };

  const isLogged = (preview) => {
    return parseInt(preview.getAttribute('data-is-logged')) === 1;
  };

  const getResourceUrl = (preview) => {
    return preview.getAttribute('data-resource-url');
  };

  const getPreviewWidth = (preview) => {
    return parseInt(preview.getAttribute('data-width'));
  };

  const getPreviewHeight = (preview) => {
    return parseInt(preview.getAttribute('data-height'));
  };

  const showPreviewDialog = (preview) => {
    const dialogImage = document.getElementById('dialog-maze-image');
    const resourceUrl = getResourceUrl(preview);
    const timestamp = Date.now();

    ks.app.showLoader();

    dialogImage.setAttribute('data-resource-url', resourceUrl);
    dialogImage.setAttribute('src', resourceUrl + '?format=jpg&mode=view&ts=' + timestamp);
    dialogImage.setAttribute('width', getPreviewWidth(preview));
    dialogImage.setAttribute('height', getPreviewHeight(preview));
  };

  const onPreviewClick = (event) => {
    const preview = event.target.closest('.maze-preview');

    if (!preview) {
      return;
    }

    if (canDownloadPreview(preview)) {
      showPreviewDialog(preview);
    } else {
      if (isLogged(preview) && isPremiumPreview(preview)) {
        ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_MAZES_PARENT_CLICK_NO_ACCESS);

        setTimeout(() => {
          window.location.href = '/parent/profile/payment';
        }, 0);
      } else {
        ks.yandex.Events.onEvent(ks.yandex.Events.EVENT_MAZES_GUEST_CLICK_NO_ACCESS);

        ks.app.showLoginEx({ reload: true });
      }
    }
  };

  const onPreviewImageLoad = () => {
    ks.app.hideLoader();

    const dialog = document.getElementById('dialog-maze');

    $(dialog).modal('show');
  };

  const onPreviewImageError = (event) => {
    if (event.target.getAttribute('src') === '#') {
      return;
    }

    ks.app.hideLoader();

    ks.app.messageBox({
        type    : ks.consts.MBT_ERROR,
        title   : 'Что-то пошло не так',
        text    : 'Не получилось загрузить лабиринт. Пожалуйста, попробуйте позже.',
        buttons : ks.consts.MBB_OK
    });
  };

  const initPreview = (preview) => {
    const actionContent = preview.querySelector('.maze-preview__action-content');

    const canDownload = canDownloadPreview(preview);

    if (canDownload) {
      actionContent.innerHTML = 'Скачать';
    } else {
      actionContent.innerHTML = isLogged(preview) && isPremiumPreview(preview) ? 'Получить доступ ко всем материалам' : 'Войдите в аккаунт, чтобы скачать';
    }

    if (!canDownload) {
      const action = preview.querySelector('.maze-preview__action');
      if (action) {
        action.classList.add('can-download');
      }
    }
  };

  const printPdf = (url) => {
    const btnPrint = document.getElementById('dialog-maze-print');

    const iframeId = 'maze-pdf-frame';
    let iframe = document.getElementById(iframeId);

    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.id = iframeId;
      document.body.appendChild(iframe);

      iframe.style.visibility = 'hidden';
      iframe.style.display = 'none';
    }

    btnPrint.disabled = true;

    iframe.onerror = () => {
      btnPrint.disabled = false;
    };

    iframe.onload = () => {
        setTimeout(function () {
            try {
              iframe.focus();
              iframe.contentWindow.print();
              URL.revokeObjectURL(url);
              // document.body.removeChild(iframe);
            } catch {}

            btnPrint.disabled = false;
        }, 1);
    };

    iframe.src = url;
  }

  const onPrintMaze = (event) => {
    event.preventDefault();

    const dialogImage = document.getElementById('dialog-maze-image');
    const url = dialogImage.getAttribute('data-resource-url');
    const timestamp = Date.now();
    const pdf = url + '?format=pdf&mode=view&ts=' + timestamp;

    printPdf(pdf);
  };

  const onDownloadMaze = (event) => {
    event.preventDefault();

    const dialogImage = document.getElementById('dialog-maze-image');
    const url = dialogImage.getAttribute('data-resource-url');
    const timestamp = Date.now();
    const pdf = url + '?format=pdf&mode=download&ts=' + timestamp;

    window.open(pdf);
  };

  const isMobile = () => {
    const userAgent = navigator.userAgent.toLowerCase();

    return /mobile|iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(userAgent);
  };

  const onDOMContentLoaded = () => {
    const previews = document.getElementsByClassName('maze-preview');

    if (previews.length <= 0) {
      return;
    }

    for (const preview of previews) {
      const imageBox = preview.querySelector('.maze-preview__img-box');

      if (!imageBox) {
        continue;
      }

      imageBox.addEventListener('click', onPreviewClick);

      initPreview(preview);
    }

    const btnPrint = document.getElementById('dialog-maze-print');
    const btnDownload = document.getElementById('dialog-maze-download');

    btnPrint.addEventListener('click', onPrintMaze);
    btnDownload.addEventListener('click', onDownloadMaze);

    if(isMobile()) {
      btnPrint.classList.add('hidden');
    }

    const dialogImage = document.getElementById('dialog-maze-image');
    dialogImage.addEventListener('load', onPreviewImageLoad);
    dialogImage.addEventListener('error', onPreviewImageError);
  };

  document.addEventListener('DOMContentLoaded', onDOMContentLoaded);
}());
